<div class="faq-wrapper">
  <div class="header">
    Frequently Asked Questions
  </div>
  <!-- end row -->
  <div class="row">
    <div class="col-lg-6 mar-b100">
      <div class="card p-0 border-16">
        <div class="card-body p-0">
          <div class="accordion" id="accordionExample2">
            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseFive" class="faq" aria-expanded="true"
                aria-controls="collapseFive">
                <div class="card-header" id="headingFive">
                  <h6 class="m-0 faq-question">What benefits do I get under this policy?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample2"
                style="">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    <table border="1" cellpadding="8" cellspacing="0" style="border-collapse: collapse; width: 100%;">
                      <thead>
                        <tr>
                          <th style="text-align:left; width: 39%;">Benefit</th>
                          <th style="text-align:left;">Coverage / Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Hospitalization Cover</td>
                          <td>Up to ₹2,00,000 (as per plan)</td>
                        </tr>
                        <tr>
                          <td>Room Rent – Twin Sharing</td>
                          <td>
                            <ul>
                              <li>₹2,500 per day (Metro cities)<br></li>
                              <li>₹2,000 per day (Non-metro cities)<br></li>
                              <li>ICU: Covered as per actuals</li>
                            </ul>

                          </td>
                        </tr>
                        <tr>
                          <td>Ambulance Charges</td>
                          <td>₹10,000 (Ambulance charges cannot be paid in Reimbursement)</td>
                        </tr>
                        <tr>
                          <td>Accidental OPD</td>
                          <td>₹10,000 (only for DE, accident cases)</td>
                        </tr>
                        <tr>
                          <td>Accidental Death Cover</td>
                          <td>₹10,00,000</td>
                        </tr>
                        <tr>
                          <td>Permanent Disability<br>(PTD / PPD)</td>
                          <td>Paid as per % of disability</td>
                        </tr>
                        <tr>
                          <td>Temporary Income Support<br>(PTD / PPD)</td>
                          <td>Daily payout if unable to work due to accident</td>
                        </tr>
                        <tr>
                          <td>Education Grant</td>
                          <td>₹25,000 per child (max 2) in case of accidental death</td>
                        </tr>
                        <tr>
                          <td>Mobile Protection (Superstar & Megastar only)</td>
                          <td>Damage due to accident leading to hospitalization (Theft not covered)
                            <br>Maximum Sum insured : ₹5,000
                          </td>
                        </tr>
                        <tr>
                          <td>Maternity (Female DE &amp; Megastar spouse)</td>
                          <td>
                            <ul>
                              <li>Normal Delivery: ₹25,000<br></li>
                              <li>C‑section: ₹40,000</li>
                            </ul>

                          </td>
                        </tr>
                        <tr>
                          <td>Teleconsultation</td>
                          <td>Talk to a doctor anytime on phone</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- collapse one end -->
            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseSix" class="faq collapsed" aria-expanded="false"
                aria-controls="collapseSix">
                <div class="card-header" id="headingSix">
                  <h6 class="m-0 faq-question">What is our policy coverage period?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample2"
                style="">
                <div class="card-body">
                  <p class="text-muted mb-0 faq-ans">
                    Policy coverage period is active on the day of order delivery and the next 7 days, so you can claim
                    Insurance within the 7 days of order delivery.
                    <br> <br>
                    <strong>Example:</strong> If you deliver an order on 1st September,
                    your insurance cover is valid till 8th September. That means you can raise a claim for any
                    hospitalization / OPD on 1st, 2nd or the 3rd of September till 8th September.

                  </p>
                </div>
              </div>
            </div>
            <!-- collapse two end -->
            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseSeven" class="faq collapsed" aria-expanded="false"
                aria-controls="collapseSeven">
                <div class="card-header" id="headingSeven">
                  <h6 class="m-0 faq-question">How can I take treatment?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample2">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    You can choose to take treatment in Cashless mode or get a
                    Reimbursement for the treatment expenses. <br>
                    <ol>
                      <br>
                      <li>Cashless – Insurance company pays the hospital directly. Non-Payables and deductions not
                        eligible as per the policy terms are to be paid by the DE</li>
                      <li>Reimbursement – You pay the hospital first, then claim money back. Non-Payables and deductions
                        noteligible as per the policy terms will be deducted.</li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>
            <!-- collapse three end -->
            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseEight" class="faq collapsed" aria-expanded="false"
                aria-controls="collapseEight">
                <div class="card-header" id="headingEight">
                  <h6 class="m-0 faq-question">What is Cashless Hospitalization?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordionExample2">
                <div class="card-body">
                  <p class="text-muted mb-0 faq-ans">
                    To avail Cashless treatment, Show your E-Card at a network hospital. The hospital will send the
                    Pre-auth approval request to IndusInd. Once approved, the insurance company pays directly to the
                    hospital. Cashless hospitalization is available only at network hospitals.
                  </p>
                </div>
              </div>
            </div>
            <!-- collapse four end -->
            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseNine" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseNine">
                <div class="card-header" id="headingNine">
                  <h6 class="m-0 faq-question">How to check network hospitals?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample2">
                <div class="card-body">
                  <p class="text-muted mb-0 faq-ans">Open Swiggy DE App ⟶ Profile ⟶ Insurance Details ⟶ Network
                    Hospitals.</p>
                </div>
              </div>
            </div>
            <!-- collapse one end -->
            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseTwo" class="faq collapsed" aria-expanded="false"
                aria-controls="collapseTwo">
                <div class="card-header" id="headingTwo">
                  <h6 class="m-0 faq-question">
                    What are the documents required to avail Cashless treatment ?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                <div class="card-body">
                  <ul class="text-muted mb-0 faq-ans">
                    <li>Health E-Card <br></li>
                    <li>Aadhaar or PAN card<br></li>
                    <li>Swiggy ID</li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- collapse two end -->
            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseThree" class="faq collapsed" aria-expanded="false"
                aria-controls="collapseSeven">
                <div class="card-header" id="headingThree">
                  <h6 class="m-0 faq-question"> How to claim Cashless treatment?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample2">
                <div class="card-body">
                  <p class="text-muted mb-0 faq-ans">Visit a network hospital → Show your E-Card → Hospital sends
                    approval request to the Insurance company → Approval usually within 3 hours.</p>
                </div>
              </div>
            </div>

            <!-- collapse three end -->
            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseFour" class="faq collapsed" aria-expanded="false"
                aria-controls="collapseEight">
                <div class="card-header" id="headingFour">
                  <h6 class="m-0 faq-question">What if a network hospital refuses cashless treatment? </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample2">
                <div class="card-body">
                  Contact support immediately via:
                  <ul class="text-muted mb-0 faq-ans">
                    <br>
                    <li>Swiggy Emergency Hotline <br></li>
                    <li>Email: gigclaims@indusindinsurance.com</li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- collapse four end -->

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_1r" class="faq collapsed" aria-expanded="false"
                aria-controls="collapseone_1r">
                <div class="card-header" id="headingOne_1r">
                  <h6 class="m-0 faq-question">What is Reimbursement?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_1r" class="collapse" aria-labelledby="headingOne_1r"
                data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    If a hospital is not on the cashless network, you can still claim the amount spent on your treatment
                    at the hospital by raising a reimbursement claim through your Swiggy DE app and submitting the
                    required documents.
                  </div>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_2r" class="faq collapsed" aria-expanded="false"
                aria-controls="collapseone_2r">
                <div class="card-header" id="headingOne_2r">
                  <h6 class="m-0 faq-question">Documents required for Reimbursement?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_2r" class="collapse" aria-labelledby="headingOne_2r"
                data-parent="#accordionExample1">
                <div class="card-body">
                  <ul class="text-muted mb-0 faq-ans">
                    <li>Original hospital bills <br></li>
                    <li>Payment receipts <br></li>
                    <li>Discharge summary <br></li>
                    <li>Test reports <br></li>
                    <li>Filled Claim form with claimed Amount <br></li>
                    <li>ID proof, (PAN card / Aadhar Card) <br></li>
                    <li>Cancelled cheque with printed name or Bank statement or Passbook</li>
                    <li>Additional Documents if any</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_3" class="faq collapsed" aria-expanded="false"
                aria-controls="collapseone_3">
                <div class="card-header">
                  <h6 class="m-0 faq-question">How to claim Reimbursement?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_3" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    After discharge from the hospital: <br> Log in to the Swiggy app → Go to 'Insurance details' → Tap on
                    'Start a Claim'
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6" style="margin-bottom: 100px;">
      <div class="card p-0 border-16">
        <div class="card-body p-0">
          <div class="accordion" id="accordionExample1">





            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_4" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_4">
                <div class="card-header">
                  <h6 class="m-0 faq-question">
                    How to track your insurance claim?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_4" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    You can check your claim status through the Swiggy delivery partner app:
                    <br> Log in to the app → Go to 'Insurance Details' → Tap on 'Track Claim'.
                  </div>
                </div>
              </div>
            </div>
            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_5" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_5">
                <div class="card-header">
                  <h6 class="m-0 faq-question">How to find E-card ?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_5" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    You can download your E-Card from the homepage of the Insurance section.
                  </div>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_6" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_6">
                <div class="card-header">
                  <h6 class="m-0 faq-question">What is OPD?</h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_6" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    OPD means treatment without hospital admission. Covered only for accident cases. Only Delivery
                    Executive can claim this. Maximum coverage ₹10,000.
                  </div>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_7" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_7">
                <div class="card-header">
                  <h6 class="m-0 faq-question">
                    What is PTD and PPD?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_7" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    PTD: Permanent Total Disability (complete disability).<br>
                    PPD: Permanent Partial Disability (partial loss like loss of a finger/hearing).<br> <br>
                    Insurance Payment depends on the percentage of loss.

                  </div>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_8" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_8">
                <div class="card-header">
                  <h6 class="m-0 faq-question">
                    What is TTD / LOP?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_8" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    If accident temporarily stops you from working, you can receive daily payouts for a limited time as
                    per plan.
                  </div>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_9" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_9">
                <div class="card-header">
                  <h6 class="m-0 faq-question">
                    What is Teleconsultation?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_9" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    You can speak to a doctor anytime by phone through the <strong>Visit App</strong> available on App
                    store and Play Store.
                  </div>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_10" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_10">
                <div class="card-header">
                  <h6 class="m-0 faq-question">
                    How to avail teleconsultation service?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_10" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    Download the Visit App from Play Store or Scan the QR code to download the app ⟶ Login using your
                    registered mobile number ⟶ Enter the OTP and start using the services
                  </div>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_11" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_11">
                <div class="card-header">
                  <h6 class="m-0 faq-question">
                    What is Maternity Benefit?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_11" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <ul class="text-muted mb-0 faq-ans">
                    <li>Applicable For Female DE and Megastar plan for spouse. <br></li>
                    <li>Normal delivery: ₹25,000 <br></li>
                    <li>C-section: ₹40,000 <br></li>
                    <li>Coverage available only for first 2 children. <br></li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_12" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_12">
                <div class="card-header">
                  <h6 class="m-0 faq-question">
                    What is Mobile Protection?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_12" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    Mobile Protection is available for Superstar & Megastar Tiers. Covers mobile damage only if accident
                    leads to hospitalization. Theft is not covered. Maximum Sum Insured : ₹5,000
                  </div>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_13" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_13">
                <div class="card-header">
                  <h6 class="m-0 faq-question">
                    How to file Accidental Death Claim?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_13" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">

                  <div class="text-muted mb-0 faq-ans">
                    Inform insurance company. <br>
                    Required documents: <br>
                    <ul>
                      <li>Submit death certificate</li>
                      <li>Hospital records</li>
                      <li>Police report (if needed)</li>
                      <li>Nominee ID / Legal Heir certificate</li>
                      <li>Bank details.</li>
                      <li>MLC/FIR</li>
                    </ul>

                  </div>
                </div>
              </div>
            </div>

            <div class="faq-card">
              <a data-toggle="collapse" href="#collapseone_14" class="faq collapsed" aria-expanded="true"
                aria-controls="collapseone_14">
                <div class="card-header">
                  <h6 class="m-0 faq-question">
                    Why should I add a Nominee?
                  </h6>
                  <img src="../../../../assets/images/grey-down-arrow.png" alt="">
                </div>
              </a>
              <div id="collapseone_14" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                <div class="card-body">
                  <div class="text-muted mb-0 faq-ans">
                    Nominee ensures insurance money goes quickly to your family without legal delays.
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end row -->

  <!-- <div class="row mt-3">
    <div class="col-12">
      <div class="note">
        <div class="alert alert-info">
          <small>** Maternity, PED, Domiciliary are add on benefits and not in the base cover of GMC, please refer your
            policy and terms and conditions for additional details<br />
            # GMC termed as Group Mediclaim</small> <br>

          <small>
            <strong>Final Advice:</strong> <br>
            <li>Save your E-card on your phone.<br></li>
            <li>Add nominee details correctly.<br></li>
            <li>Inform immediately during emergencies.<br></li>
            <li>Keep bills and documents safely.<br></li>
            Your safety and family security are important.<br>
          </small>
        </div>
      </div>
    </div>
  </div> -->
</div>